import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAppBar,{attrs:{"app":"","color":"#FFBD00","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('router-link',{attrs:{"to":"/"}},[_c(VImg,{staticClass:"shrink mr-2",attrs:{"alt":"VTSV","contain":"","src":require("@/assets/logo-vtsv-2.jpg"),"transition":"scale-transition","width":"180","height":"50"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }